import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Dialog } from "../me/index.js";
import { RueckfrageGastgeber } from "./VerwerfenRueckfrage.js";
import { StrikteEbene, useImModal, useStrikteWege } from "./strikteHuelle.js";
/** F121: Grenzen und Umschaltpunkt des Panels — in der Hülle, nie beim Aufrufer (F41). */
const PANEL_BREITE_MIN = 640;
const PANEL_BREITE_MAX = 960;
const PANEL_VOLLFLAECHIG_AB = 1024;
export function Arbeitsdialog(p) {
    const imModal = useImModal();
    const { anker, steuerung } = useStrikteWege(p);
    /*
     * Ohne `panel`: `unter="stapel"` fest — liegt der Arbeitsdialog seinerseits über einem offenen
     * Dialog, kann ein vollflächiges Blatt nur darüber liegen, nie daneben.
     * Mit `panel`: kein `unter` (sonst kein Griff, siehe Kopf).
     * Den Namen gibt das Element seiner Ebene aus dem Titel (wie beim `Modal`).
     */
    const flaeche = p.panel === undefined
        ? { breite: "voll", unter: "stapel", className: "ki-arbeitsdialog" }
        : {
            lage: "rechts", breite: "inhalt", breiteMin: PANEL_BREITE_MIN, breiteMax: PANEL_BREITE_MAX,
            verstellbar: true, merken: p.panel, vollflaechigAb: PANEL_VOLLFLAECHIG_AB,
            className: "ki-arbeitsdialog ki-arbeitsdialog--panel",
        };
    return (_jsx(StrikteEbene, { imModal: imModal, children: _jsxs(Dialog, { ref: steuerung, offen: true, strikt: true, art: "arbeit", ...flaeche, titel: _jsx("span", { ref: anker, children: p.titel }), ...(p.pfad === undefined ? {} : { pfad: p.pfad }), steckbrief: p.steckbrief, meldungen: p.meldungen, register: p.register, hinweis: p.hinweis, fussLinks: p.fussLinks, fuss: p.fuss, children: [p.children, _jsx(RueckfrageGastgeber, {})] }) }));
}
//# sourceMappingURL=Arbeitsdialog.js.map